"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_FR_TRANS = {
    'time picker': 'Choisir l\'heure',
    'today': 'Aujourd\'hui',
    'set time': 'Confirmer l\'heure',
    'close': 'Fermer',
    'cancel': 'Annuler',
    'confirm': 'Confirmer',
    'hour': 'Heure',
    'minute': 'Minute',
    'second': 'Seconde',
};
//# sourceMappingURL=fr.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/fr.js
// module id = ../../../../ng-pick-datetime/locale/fr.js
// module chunks = 15